import * as React from "react";

function SvgMammoth(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33.1 32.3"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M24.9 0H6.5C2.9 0 0 3 0 6.6V31c0 .7.6 1.3 1.3 1.3h5.6c.7 0 1.3-.6 1.3-1.3V18.2c0-.7.6-1.3 1.3-1.3h1.7c.7 0 1.3.6 1.3 1.3V31c0 .7.6 1.3 1.3 1.3h5.6c.7 0 1.3-.6 1.3-1.3V18.2c0-.7.6-1.3 1.3-1.3h1.6c.7 0 1.3.6 1.3 1.3V31c0 .7.6 1.3 1.3 1.3h5.7c.7 0 1.3-.6 1.3-1.3V1.3c0-.7-.6-1.3-1.3-1.3h-7z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#02b875"
      />
    </svg>
  );
}

export default React.forwardRef(SvgMammoth);
